import { HTMLAttributes } from 'react'

export default (props: HTMLAttributes<SVGElement>) => (
  <>
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{backgroundColor: 'var(--button-bg-color)'}}
    >
      {/* <g clipPath='url(#clip0_101_2)'> */}
      <g transform='translate(9.6, 4.50)'>
        <path
          d='m0,5.52h3.72v9.58H0V5.52ZM3.72,0H0v3.32h3.72V0Z'
          fill='var(--button-label-color)'
        />
      </g>
    </svg>
  </>
)
